import React from "react";
import {useTranslation} from "react-i18next";

import {TableShowMoreMenu} from "@vedmarket/ui-kit";

type Props = {
  onOpen(): void
}

const Settings = ({onOpen}: Props) => {

  const { t } = useTranslation();

  return (
    <TableShowMoreMenu
      menuItems={[
        {
          title: t('actions__text__open'),
          onClick: onOpen,
        },
      ]}
    />
  );
};

export default Settings;
